import { render, staticRenderFns } from "./FundRecord.vue?vue&type=template&id=11ad485c&scoped=true&"
import script from "./FundRecord.vue?vue&type=script&lang=js&"
export * from "./FundRecord.vue?vue&type=script&lang=js&"
import style0 from "./FundRecord.vue?vue&type=style&index=0&id=11ad485c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ad485c",
  null
  
)

export default component.exports